import React from "react";
import { Phone, Siren } from "lucide-react";
import { CONTACT } from "@/data/content";

const Segment = () => (
  <span className="inline-flex items-center gap-2 px-6 text-[13px] sm:text-sm font-semibold leading-none">
    <Siren className="w-4 h-4 shrink-0 animate-pulse" />
    Urgence 24/48h — sinistre, vandalisme, retour de location, restitution d'appartement.
    <span className="font-extrabold">Devis en 24h.</span>
    <span className="font-extrabold">Caution rendue ou 2ᵉ passage offert.</span>
    <span className="inline-flex items-center gap-1.5 font-extrabold">
      <Phone className="w-4 h-4" /> {CONTACT.phone}
    </span>
    <span className="opacity-50 px-2">◆</span>
  </span>
);

const Group = () => (
  <span className="flex items-center shrink-0">
    {[0, 1, 2, 3].map((i) => (
      <Segment key={i} />
    ))}
  </span>
);

export const EmergencyBar = () => {
  return (
    <a
      data-testid="emergency-top-bar"
      href={CONTACT.phoneHref}
      className="block w-full bg-alert text-alert-foreground overflow-hidden whitespace-nowrap"
      aria-label={`Urgence 24/48h — appeler le ${CONTACT.phone}`}
    >
      <div className="flex marquee-slow w-max py-2.5">
        <Group />
        <Group />
      </div>
    </a>
  );
};
